import logo from "@assets/tournaments/asoprof/logo.png";
import escudo from "@assets/tournaments/asoprof/escudo.webp";
import bannerImage from "@assets/tournaments/asoprof/banner.png";
import bannerMobileImage from "@assets/tournaments/asoprof/banner-mobile.png";
import asoprofRules from "./lineupRules/asoprof";

const asoprof = {
  id: "asoprof",
  name: "COPA DE LA AMISTAD DE FÚTBOL - AsoProf",
  logo,
  escudo,
  gaId: "G-JJ07DJS4F9",
  footerLinks: [
    {
      label: "Reglamento",
      icon: "icon-pdf",
      href: "https://api.futbolasociadoasoprof.com/static/reglamento.pdf",
    },
    {
      label: "Estadísticas",
      icon: "icon-users",
      href: "https://futbolasociadoasoprof.com/statistics",
    },
  ],
  // Bandas de edad del carnet, con las claves que envía el backend en `media`.
  ageBands: {
    // De menor a mayor edad; define el orden de las listas de jugadores.
    order: ["goalkeeper", "young", "middle", "old", "old_more", "too_old"],
    // Fondo del jugador en la cancha (componente Lineups).
    lineupColors: {
      too_old: "var(--text-light)",
      old_more: "var(--blue)",
      old: "var(--red)",
      middle: "var(--green)",
      young: "var(--accent)",
      default: "var(--widget-dark)",
    },
    // Borde del avatar en las filas de jugadores.
    avatarColors: {
      young: "var(--accent)",
      too_old: "var(--text-light)",
      old_more: "var(--blue)",
      middle: "var(--green)",
      old: "var(--red)",
      goalkeeper: "var(--widget-dark)",
    },
    // Nombre, rango de edad y color de texto de cada carnet (tablero del delegado).
    // El color de fondo es el de avatarColors.
    carnets: {
      goalkeeper: { label: "Arquero", short: "ARQ", text: "#fff" },
      young: { label: "Amarillo", short: "32-34", text: "#111" },
      middle: { label: "Verde", short: "35-39", text: "#fff" },
      old: { label: "Rojo", short: "40-44", text: "#fff" },
      old_more: { label: "Azul", short: "45-49", text: "#fff" },
      too_old: { label: "Plateado", short: "50+", text: "#111" },
    },
  },
  // Rutas del backend de este torneo que difieren entre APIs.
  api: {
    // Eventos del partido que consumen TeamsLineups y TeamCompare.
    lineupEventsPath: "event/byGame",
  },
  // Pantalla del día del partido (TeamsLineupsDay).
  matchDay: {
    attendanceTitle: "Presencia (sin Jugar)",
    // En finales (typestage 2) solo se listan los jugadores con asistencia.
    onlyAttendedInFinals: true,
    // Máximo de jugadores en cancha por equipo (no se puede forzar).
    maxOnField: 11,
    // Estados del partido en los que se puede remover a un titular.
    starterRemovableStatuses: [1, 5],
    // Qué hace tocar a un jugador de la lista de asistencia:
    // "events" abre sus eventos, "removeStarter"/"removeAttendance" piden confirmación.
    attendanceAction: (match) => (match ? "events" : null),
  },
  // Vista pública del partido (TeamsLineups).
  lineupView: {
    showAttendanceList: false,
    hideDismissedFromField: false,
  },
  // Pantalla "Mi Equipo" (/players-sumary, rol club): si el club puede
  // inscribir jugadores nuevos y editar los existentes (datos y foto).
  // En false los botones quedan deshabilitados; el backend no lo valida.
  playerManagement: {
    allowCreate: false,
    allowEdit: false,
  },
  // Portada: diseño (layouts.js), widgets en orden de aparición y reglas de partidos.
  home: {
    // Cabecera de la portada (LeagueHero); se le agrega el año actual al subtítulo.
    hero: { title: "Copa de la Amistad de Fútbol", subtitle: "AsoProf" },
    layout: "home_full",
    widgets: [
      "champions",
      "team_stats",
      "banner",
      "month_matches",
      "live_report",
      "warnings",
      "warnings2",
    ],
    banner: {
      href: "https://linktr.ee/Master_Buc",
      image: bannerImage,
      mobileImage: bannerMobileImage,
    },
    // Últimos resultados y en vivo.
    recentGames: {
      statuses: [2, 5, 6, 7, 8],
      fromDate: "2025-06-18T00:00:00", // no muestra partidos anteriores
      emptyMessage: "No hay partidos finalizados.",
    },
    // Próximos partidos.
    upcomingGames: {
      statuses: [1, 3, 4],
      fromDate: "2025-06-18T00:00:00",
    },
  },
  // Reglamento de LINEUPS (ingreso, sustitución, presencia).
  lineupRules: asoprofRules,
  // Título de la página de estadísticas del torneo en curso (los anteriores salen de game/championshipold).
  statistics: {
    currentTitle: "Estadísticas torneo finalización 2026",
  },
  support: {
    whatsappUrl: "https://wa.link/hrfllh",
  },
  // Documentos de la página DIAN: lista plana en orden de aparición; `file` es relativo a REACT_APP_URL_BK.
  dianDocuments: [
    {
      name: "Régimen Especial",
      detail: "R.E",
      file: "static/regimen_especial.pdf",
    },
    {
      name: "Certificado de Pagos",
      detail: "Certificado de pagos a cargos directivos",
      file: "static/pagos.pdf",
    },
    {
      name: "Presupuestos",
      detail: "Presupuestos",
      file: "static/presupuestos.pdf",
    },
    {
      name: "Certificado de Permanencia ESAL",
      detail: "Certificado de Permanencia ESAL",
      file: "static/esal.pdf",
    },
    {
      name: "Dictamen revisoría fiscal",
      detail: "D.R.F",
      file: "static/distamen_revisoria_fiscal.pdf",
    },
    {
      name: "Firma Electrónica",
      detail: "Firma Electrónica",
      file: "static/firma_electronica.pdf",
    },
    {
      name: "Informe de Gestión",
      detail: "Informe de Gestión",
      file: "static/gestion.pdf",
    },
    {
      name: "Estados Financieros 2025",
      detail: "Estados Financieros 2025",
      file: "static/estados_financieros.pdf",
    },
    {
      name: "Antecedentes",
      detail: "Certificado de Antecedentes",
      file: "static/antecedentes.pdf",
    },
  ],
  // Página Fase final (llave de eliminatorias, src/bracket + widgets/FinalBracket).
  bracket: {
    title: "Cuadro Final Torneo Clausura",
    backLink: { label: "Tabla de Posiciones final", to: "/statistics" },
    // Según la etapa del torneo: enlace "Fase final" en el menú y llave en la portada.
    // La ruta /fase-final existe siempre (sirve para revisarla antes de mostrarla).
    showInMenu: false,
    showOnHome: false,
    // Nombre del equipo comodín que ocupa los cupos aún sin definir (y el rival de un bye).
    placeholderTeamName: "Por definir",
  },
  // Documentos de la página Formatos (opcional: sin esta lista no hay ruta ni enlace de menú).
  formatosDocuments: [
    {
      name: "Formato de Inscripción",
      detail: "Inscripción",
      file: "static/formato_inscripcion.pdf",
    },
    {
      name: "Formato Paz y Salvo",
      detail: "Formato Paz y Salvo",
      file: "static/formato_paz_y_salvo.pdf",
    },
    {
      name: "Planilla de Inscripción",
      detail: "Inscripción",
      file: "static/planilla_inscripcion.pdf",
    },
  ],
  // Documentos de la página Nosotros (opcional: sin esta lista no hay ruta ni enlace de menú).
  nosotrosDocuments: [
    {
      name: "Estatutos",
      detail: "Estatutos",
      file: "static/estatus.pdf",
    },
    {
      name: "Personería Jurídica",
      detail: "P.J",
      file: "static/personeria_juridica.pdf",
    },
    {
      name: "Plan de Desarrollo deportivo",
      detail: "Presupuestos",
      file: "static/plan_deportivo.pdf",
    },
    {
      name: "Código disciplinario",
      detail: "Código disciplinario",
      file: "static/codigo_disiplinario.pdf",
    },
    {
      name: "Reglamento",
      detail: "Reglamento 2025",
      file: "static/reglamento.pdf",
    },
  ],
  // Códigos de campeonato del backend de este torneo.
  championships: {
    actual: 5, // campeonato en curso
    staff: 5, // campeonato donde se registran árbitros/asistentes (equipos 5 y 6)
    transfer: 5, // campeonato usado al crear jugadores por traspaso
  },
};

export default asoprof;
